<ion-content>
  <!-- data still loading -->
  <ion-grid *ngIf="appPrescriptionDates === undefined">
    <ion-row>
      <ion-col class="c3-flex ion-align-items-center ion-justify-content-center">
        <ion-spinner color="secondary"></ion-spinner>
      </ion-col>
    </ion-row>
  </ion-grid>

  <!-- app is not prescribed - show warn message -->
  <ion-grid *ngIf="appPrescriptionDates === null && !appPrescrEnded">
    <ion-row>
      <ion-col class="c3-flex-column ion-align-items-center ion-justify-content-center">
        <ion-icon size="large" color="secondary" [src]="'information-outline' | getIcon"></ion-icon>

        <p>
          A questo paziente non è ancora stata attivata un'app e quindi non è possibile visualizzare
          o modificare il piano di cura.
        </p>
        <p>Clicca sul bottone sottostante per iniziare l'attivazione di un'app.</p>

        <ion-button (click)="goToAppPrescription()" color="primary">
          <span>Attiva un'app</span>
          <ion-icon slot="end" [src]="'cellphone-cog' | getIcon"></ion-icon>
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>

  <!-- app is prescribed - show tp -->
  <ng-container *ngIf="appPrescriptionDates || appPrescrEnded">
    <!-- app prescr end msg -->
    <ion-card class="app-end-app-prescr-msg-box" color="primary" *ngIf="appPrescrEnded">
      <ion-card-content>
        <p>
          Modifica il piano di cura del paziente. Ricordati di salvare ogni sezione se hai apportato
          delle modifiche. Una volta concluse le modifiche al piano di cura, clicca sul bottone
          sottostante.
        </p>

        <ion-button (click)="onEndAppPrescr()" color="light" class="ion-margin-top">
          <span>Concludi attivazione app</span>
        </ion-button>
      </ion-card-content>
    </ion-card>

    <c3-page-with-index #pageWithIndex [menuConfiguration]="menuConfs">
      <router-outlet name="treatment-plan"></router-outlet>
    </c3-page-with-index>

    <div class="app-bottom-padding-prescription-to-end" *ngIf="appPrescrEnded"></div>
  </ng-container>
</ion-content>